export default __webpack_public_path__ + "static/media/dieppe25.4de5ffd2.jpg";